







import Vue from 'vue'
export default Vue.extend({
    props: ['signintext'],
    methods: {
        signIn(type) {
            this.$emit('signInClick', type);
        }
    }
})
